<template>
    <BasicModalWindow
      ref="modal"
      class="image-upload"
      title="editor.images.title"
    >
        <template #body>
            <FileUploadSelect
              @fileUploadSubmit="onFileUploadSubmit"
            />

              <div class="control-group web-image">
                  <div class="control">
                      <label for="web-image-input">
                          {{Language.say('editor.images.web_url')}}
                      </label>
                      <input
                        @change="onWebImageChange"
                        v-model="image_preview_input"
                        id="web-image-input"
                        type="text"
                      />

                      <div class="image-preview">
                        <span><img v-if="image_preview_source" :src="image_preview_source" /></span>
                        <small v-if="!image_loading_error">
                          {{Language.say('editor.images.preview_1')}} <br>
                          {{Language.say('editor.images.preview_2')}}
                        </small>
                        <small v-if="image_loading_error" class="error">
                          {{Language.say('editor.images.preview_error')}}
                        </small>
                      </div>
                  </div>
              </div>
        </template>

        <template #footer>
            <ActionButton
              @click="close()"
              text="global.actions.close"
            />

          <ActionButton
              @click="onSubmitImage()"
              class='main-action push-right'
              text="global.actions.confirm"
              :disabled="action_disabled"
              :loading="image_loading"
          />
        </template>
    </BasicModalWindow>
</template>

<script setup>
  import { ref, defineEmits } from 'vue';
  import FileUploadSelect     from '../Partials/FileUploadSelect.vue';
  import BasicModalWindow     from '@/vue/Layouts/Modals/BasicModalWindow.vue';
  import ActionButton         from '@/vue/Elements/Buttons/ActionButton.vue'
  import Language             from '@/js/Shared/Language/Language.js';

  const emit = defineEmits([
    'inlineImagesDrop', 'remoteImageSubmit'
  ])

  const modal                = ref();
  const action_disabled      = ref(true);
  const image_preview_source = ref('');
  const image_preview_input  = ref('');
  const image_loading        = ref('');
  const image_loading_error  = ref(false);

  const onFileUploadSubmit = (data) => {
    emit('inlineImagesDrop', data);
    close();
  }

  const onWebImageChange = (event) => {
    loadImage();
  }

  const onSubmitImage = () => {
    emit('remoteImageSubmit', image_preview_source.value);
    close();
  }

  const loadImage = () => {
    setImagePreviewSource(null);
    setImageLoading(true);
    setImageLoadingError(false);
    setActionDisabled(true);

    if (!image_preview_input.value) {
      return;
    }

    let image  = new Image();
    image.src  = image_preview_input.value;

    image.onload = (event) => {
      setImagePreviewSource(image_preview_input.value);
      setActionDisabled(false);
      setImageLoading(false);
    }

    image.onerror = (event) => {
      setImageLoading(false);
      setImageLoadingError(true);
    }
  }

  const close = () => {
    modal.value.close();
  }

  const setImagePreviewSource = (value) => {
    image_preview_source.value = value;
  }

  const setImageLoading = (value) => {
    image_loading.value = value;
  }

  const setImageLoadingError = (value) => {
    image_loading_error.value = value;
  }

  const setActionDisabled = (value) => {
    action_disabled.value = value;
  }
</script>
